import { FC } from 'react';
import { useSelector } from 'react-redux';
import { StyledNavBarIcon } from '../BaseNavbar.styles';
import {
  BackToPlatformContainer,
  BackToPlatformText,
} from './BackToPlatformLink.styles';
import * as Types from 'src/types';

interface Props {
  navOpen?: boolean;
}

export const BackToPlatformLink: FC<Props> = ({ navOpen = true }) => {
  const d1pHomeUrl = useSelector(
    (state: Types.State) => state.organisation.organisation?.d1pHomeUrl,
  );
  const isLegacyMode = useSelector(
    (state: Types.State) => state.organisation.isLegacyMode,
  );

  if (!d1pHomeUrl || isLegacyMode) return null;

  return (
    <BackToPlatformContainer
      data-testid="back-to-platform-link"
      href={d1pHomeUrl}
    >
      <StyledNavBarIcon className="uil uil-angle-left" size="20px" />
      <BackToPlatformText $navOpen={navOpen}>
        Home (Platform)
      </BackToPlatformText>
    </BackToPlatformContainer>
  );
};
